// Admin Audit Log — Super Admin only. Read-only chronological list.
import React, { useEffect, useState } from 'react';
import { adminAxios, useAdminAuth } from './AdminAuthContext';
import { Loader2, ScrollText } from 'lucide-react';

const fmt = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }); } catch { return iso; }
};

const ACTION_LABEL = {
  'admin.login': 'Login realizado',
  'admin.logout': 'Logout',
  'admin.password_changed': 'Senha alterada',
  'admin.created': 'Admin criado',
  'admin.updated': 'Admin atualizado',
};

const AdminAudit = () => {
  const { token } = useAdminAuth();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await adminAxios(token).get('/api/admin/audit-log?limit=200');
        setEntries(r.data.entries || []);
      } catch { /* surfaced via empty list */ }
      finally { setLoading(false); }
    };
    load();
  }, [token]);

  return (
    <div className="space-y-4" data-testid="admin-audit-page">
      <div>
        <h1 className="text-2xl font-black text-[#0F1C2E] flex items-center gap-2">
          <ScrollText className="w-5 h-5" /> Auditoria
        </h1>
        <p className="text-xs text-[#475569]">Registro de todas as ações dos admins, com IP e horário (últimos 200 eventos)</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-[#1E3A5F]" /></div>
      ) : entries.length === 0 ? (
        <p className="text-sm text-[#94A3B8]">Nenhum evento registrado ainda.</p>
      ) : (
        <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#F8FAFC] text-[10px] uppercase tracking-wider text-[#475569] border-b border-[#E2E8F0]">
                <th className="px-3 py-2 text-left">Quando</th>
                <th className="px-3 py-2 text-left">Quem</th>
                <th className="px-3 py-2 text-left">Ação</th>
                <th className="px-3 py-2 text-left">Alvo</th>
                <th className="px-3 py-2 text-left">IP</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e, i) => (
                <tr key={i} className="border-b border-[#F4F6F8] hover:bg-[#F8FAFC]">
                  <td className="px-3 py-2 text-[#475569] text-xs whitespace-nowrap">{fmt(e.ts)}</td>
                  <td className="px-3 py-2 text-[#0F1C2E] text-xs">{e.admin_email}</td>
                  <td className="px-3 py-2 text-xs font-medium text-[#1E3A5F]">{ACTION_LABEL[e.action] || e.action}</td>
                  <td className="px-3 py-2 text-[#475569] text-xs">{e.target || '—'}</td>
                  <td className="px-3 py-2 text-[#94A3B8] text-[11px] font-mono">{e.ip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminAudit;
